import {offerItems,hasOfferDiscount} from './aa-offer-cart.js?v=aa-currency-20261011-2';
import {currencyContext} from './aa-offer-currency.js?v=aa-currency-20261011-2';
/* Draft storefront helper: never changes cart totals or prices. Shopify is authoritative. */
const rulesCache=new Map();
const getRules=url=>{
 if(!rulesCache.has(url))rulesCache.set(url,fetch(url).then(r=>{if(!r.ok)throw Error('Offer configuration unavailable');return r.json();}));
 return rulesCache.get(url);
};
class AAOfferProgress extends HTMLElement {
 connectedCallback(){
  this.controller?.abort();this.controller=new AbortController();
  this.revision=0;
  const initial=this.querySelector('[data-offer-cart]');
  try{this.render(JSON.parse(initial?.textContent||'{}'));}catch{this.hidden=true;}
  document.addEventListener('cart:change',e=>this.render(e.detail?.cart),{signal:this.controller.signal});
  document.addEventListener('cart:refresh',()=>this.refresh(),{signal:this.controller.signal});
 }
 disconnectedCallback(){this.controller?.abort();this.revision++;}
 async refresh(){
  try{const r=await fetch(`${window.Shopify?.routes?.root||'/'}cart.js`,{headers:{Accept:'application/json'}});if(r.ok)await this.render(await r.json());}catch{this.hidden=true;}
 }
 async render(cart){
  const revision=++this.revision;
  try{
   const config=await getRules(this.dataset.config);
   if(!this.isConnected||revision!==this.revision)return;
   const context=currencyContext(config,cart.currency),bundle=context.offerMoney(context.offerBundleCents);
   const qualifying=offerItems(cart,config,context);
   const quantity=qualifying.reduce((n,item)=>n+item.quantity,0);
   this.hidden=!quantity&&!this.hasAttribute('data-force-visible');
   const applied=hasOfferDiscount(cart);
   const remainder=quantity%4,needed=remainder?4-remainder:quantity>=4?0:4;
   let message;
   if(quantity<4)message=`Add ${needed} more ${needed===1?'piece':'pieces'} for 4 for ${bundle}.`;
   else if(applied)message=`${Math.floor(quantity/4)} ${quantity<8?'bundle':'bundles'} at ${bundle}${remainder?` · ${remainder} extra ${remainder===1?'piece':'pieces'} at regular price`:''}.`;
   else message='Four eligible pieces selected. Check the offer in your cart before checkout.';
   this.querySelector('[role=status]').textContent=message;
   const progress=this.querySelector('progress');progress.value=quantity>=4&&!remainder?4:remainder;
  }catch{if(revision===this.revision)this.hidden=true;}
 }
}
if(!customElements.get('aa-offer-progress'))customElements.define('aa-offer-progress',AAOfferProgress);
